if (!customElements.get('hair-care-routine-offer')) {
  customElements.define(
    'hair-care-routine-offer',
    class HairCareRoutineOffer extends HTMLElement {
      constructor() {
        super();

        this.buttons = this.querySelectorAll('[data-hair-routine-submit]');
        this.error = this.querySelector('[data-hair-routine-error]');
        this.available = this.dataset.available === 'true';
        this.buttons.forEach((button) => button.addEventListener('click', this.onSubmit.bind(this)));
      }

      setLoading(isLoading) {
        this.buttons.forEach((button) => {
          if (isLoading) {
            button.dataset.originalText = button.textContent.trim();
            button.textContent = this.dataset.loadingLabel || button.textContent;
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.textContent = button.dataset.originalText || button.textContent;
            if (this.available) button.removeAttribute('aria-disabled');
          }
        });
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || this.dataset.errorLabel;
        this.error.hidden = false;
      }

      clearError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }

      async onSubmit(event) {
        const button = event.currentTarget;
        if (!this.available || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const variantId = Number(this.dataset.bundleVariantId);
        if (!variantId) {
          this.showError();
          return;
        }

        this.clearError();
        this.setLoading(true);

        try {
          const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
          const endpoint = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          const parsed = await response.json();

          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || this.dataset.errorLabel);
          }

          window.location.href = this.dataset.cartUrl || window.routes?.cart_url || '/cart';
        } catch (error) {
          console.error('Hair care routine add failed:', error);
          this.showError(error.message);
          this.setLoading(false);
        }
      }
    }
  );
}
